import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ThemeToggleComponent } from '@/app/shared/components/theme-toggle/theme-toggle.component';
import { ParticlesComponent } from '@/app/shared/components/ui/particles/particles.component';
import { MagicCardComponent } from '@/app/shared/components/ui/magic-card/magic-card.component';
import { UbAccordionContentDirective, UbAccordionDirective, UbAccordionItemDirective, UbAccordionTriggerDirective } from '@/app/shared/components/ui/accordion.directive';

@Component({
  standalone: true,
  selector: 'app-contact-us',
  imports: [
    CommonModule,
    FormsModule,
    ThemeToggleComponent,
    ParticlesComponent,
    MagicCardComponent,
    UbAccordionDirective,
    UbAccordionItemDirective,
    UbAccordionTriggerDirective,
    UbAccordionContentDirective,
  ],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss',
})
export class ContactUsComponent {
  isMobileMenuOpen = false;
  isDarkTheme = true;
  
  // Form data
  contactForm = {
    name: '',
    email: '',
    company: '',
    phone: '',
    subject: '',
    message: '',
    inquiryType: 'general'
  };

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent) {
    if (this.isMobileMenuOpen) {
      this.isMobileMenuOpen = false;
    }
  }

  onThemeChange(isDarkMode: boolean) {
    this.isDarkTheme = isDarkMode;
  }

  onSubmit() {
    // Handle form submission
    console.log('Form submitted:', this.contactForm);
    // Here you would typically send the data to your backend
    alert('Thank you for your message! We\'ll get back to you soon.');
    
    // Reset form
    this.contactForm = {
      name: '',
      email: '',
      company: '',
      phone: '',
      subject: '',
      message: '',
      inquiryType: 'general'
    };
  }
}